<template>
  <div v-bind="$attrs">

    <v-label
      v-if="label"
      :editable="editableLabel"
      :text="label"
      @update="$emit('update:label', $event)">
    </v-label>

    <div class="select" :class="selectClass">
      <select 
        :value="value" 
        @change="select($event.target.value)"
        @blur="blur($event.target.value)"
        :required="required"
        :disabled="disabled"
      >
        <option
          v-for="(option, i) in options"
          :key="'option-' + i"
          :value="
            itemValue
              ? isFunction(itemValue) 
                ? itemValue(option)
                : option[itemValue] 
              : isObject(option)
                ? option['value']
                : option
          "
        >
          {{ 
            itemText 
              ? isFunction(itemText) 
                ? itemText(option) 
                : option[itemText] 
              : isObject(option)
                ? option['label']
                : option 
          }}
        </option>
      </select>
    </div>

    <div class="level" v-if="hasError">
      <div class="help has-text-danger pl-1">
        <div 
          v-for="(error, i) in errors"
          :key="i">
          {{ error }}
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import VLabel from '@/components/base/VLabel'
import validatable from '@/mixins/validatable'
import helpers from '@/helpers'

export default {
  props: {
    value: {
      type: [String, Number, Object, Boolean]
    },
    itemText: {
      type: [String, Function]
    },
    itemValue: {
      type: String
    },
    options: {
      type: Array,
      required: true
    },
    label: {
      type: [String, Number],
      default: null
    },
    editableLabel: {
      type: Boolean,
      default: false
    },
    isFullwidth: {
      type: Boolean,
      default: true
    },
    isSmall: {
      type: Boolean,
      default: false
    },
    isMedium: {
      type: Boolean,
      default: false
    },
    isLarge: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  },
  components: { VLabel },
  mixins: [validatable],
  data() {
    return {
      isFunction: helpers.isFunction,
      isObject: helpers.isObject
    }
  },
  computed: {
    hooks() {
      return {
        ...this.$listeners
      }
    },
    selectClass({ isFullwidth, isSmall, isMedium, isLarge, hasError }) {
      return {
        'is-fullwidth': isFullwidth,
        'is-small': isSmall,
        'is-medium': isMedium,
        'is-large': isLarge,
        'is-danger': hasError
      }
    }
  },
  methods: {
    select(v) {
      this.$emit('input', v);
      this.validate(v);
    },
    blur(v) {
      this.$emit('blur', v);
      this.validate(v);
    }
  }
}
</script>

<style scoped>
</style>
